import { type PropsWithChildren } from "react";

import { T } from "@repo/transifex";

type LayoutProps = PropsWithChildren<{
  title?: React.ReactNode;
  header?: React.ReactNode;
  banner?: React.ReactNode;
  tabs?: React.ReactNode;
  footer?: React.ReactNode;
}>;

export const CollectBasketLayout = ({
  children,
  title,
  header,
  banner,
  tabs,
  footer
}: LayoutProps) => {
  return (
    <div className="flex flex-1 flex-col gap-6 rounded-2xl bg-interface-neutral-1 pt-8 shadow-md">
      <div className="flex h-14 flex-row items-center justify-between px-8">
        <h1 className="text-3xl font-bold leading-7 text-interface-neutral-6">
          {title ?? <T _str="Basket" />}
        </h1>

        {header}
        {tabs}
      </div>

      {banner ? <div className="mx-8">{banner}</div> : null}

      <div className="mx-8 flex-1 overflow-y-scroll">{children}</div>

      {footer ? (
        <div className="flex w-full gap-2 p-3 outline outline-1 outline-offset-1 outline-interface-neutral-3 *:w-full">
          {footer}
        </div>
      ) : null}
    </div>
  );
};
